// routes/CommonRoutes.jsx
import React from "react";
import { Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import RedirectingPage from "../pages/RedirectingPage";
import Error404 from "../pages/Error404";
import InviteConfirmationPage from "../pages/InvitePage/InviteConfirmationPage";
import AssessmentConfirmationPage from "../pages/InvitePage/AssessmentConfirmationPage";
import ContactUser from "../pages/ContactUser";
import LogoutPage from "../pages/LogoutPage";
import UserProfile from "../pages/UserProfile";
import Unsubscribe from "../pages/Unsubscribe";
// import SecurityMaintenancePage from "../pages/SecurityMaintenancePage";

const CommonRoutes = (
  <>
    <Route
      path="/accept_invite/:manager_id"
      element={<InviteConfirmationPage />}
    />
    <Route
      path="/accept_assessment/:manager_id/:user_id/:assessment_id"
      element={<AssessmentConfirmationPage />}
    />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={<Navigate to="/login" />} />
    <Route path="/redirect" element={<RedirectingPage />} />
    <Route path="/logout" element={<LogoutPage />} />
    <Route path="/unauthorised" element={<Error404 />} />
    <Route path="/contact" element={<ContactUser />} />
    <Route path="/profile/:userid" element={<UserProfile />} />
    <Route path="/unsubscribe" element={<Unsubscribe />} />
    <Route path="*" element={<Error404 />} />
    {/* <Route path="*" element={<SecurityMaintenancePage />} /> */}
  </>
);

export default CommonRoutes;
